export default {"src":"/_next/static/media/vtho.22b6293a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};